import {
  Grid,
  List,
  ListItem,
  ListItemText,
  TextField,
} from '@material-ui/core'
import BigNumber from 'bignumber.js'
import { formatDate } from '../../../helpers/StringNumberFunction/formatDate'
import React, { useState } from 'react'
import { Controller, useForm } from 'react-hook-form'
import NumberFormat from 'react-number-format'
import { useLocation } from 'react-router'
import SubInfoDollarIcon from '../../../assets/icons/Money/subinfo-dollar.svg'
import CardContents from '../../../components/CardList/CardContents'
import EmptyList from '../../../components/CardList/EmptyList'
import DynamicSubHeader from '../../../components/Header/DynamicSubHeader'
import MainHeader from '../../../components/Header/MainHeader'
import { ContentWrapper } from '../../../components/Layout/ContentWrapper'
import IconText from '../../../components/Typography/IconText'
import { amtStr } from '../../../helpers/StringNumberFunction/numFormatter'
import { DynamicFooter } from '../../Footer/DynamicFooter'
interface locationState {
  state: {
    docAmt?: number
    description?: string
    docNo?: string
    docDate?: string
  }
}

export const AllocationPage = ({ header, subheader, item }: any) => {
  return (
    <>
      <Header header={header} />
      <Subheader />
      {/* mount empty list if no item */}
      {item?.list?.length === 0 && (
        <ContentWrapper multiDynamicInfo float>
          <CardContents
            section={{
              header: {
                title: (
                  <div style={{ display: 'flex' }}>
                    <span style={{ flex: '1 1' }}>Document</span>
                    <span>Allocate Amt</span>
                  </div>
                ),
              },
            }}
          >
            <EmptyList
              title={`No document can be allocated to on this contract`}
            />
          </CardContents>
        </ContentWrapper>
      )}
      {/* mount listing only if got item */}
      {!!item?.list && item?.list?.length > 0 && <Listing item={item} />}
    </>
  )
}

const Header = ({ header }) => {
  const mainBtn = 'close'
  const smTitle = header?.smTitle
  const title =
    JSON.parse(localStorage.getItem('loggedInUser'))?.companyName ||
    'Company Name'

  const routeSegments = header?.routeSegments
  const onClick = header?.onClickRoute

  const currency =
    JSON.parse(localStorage.getItem('loggedInUser'))?.companyCurrencyCode ||
    'MYR'

  // const sideBtn = 'back'
  // const onClickAction = () => {
  //   history.push('/')
  // }

  return (
    <MainHeader
      mainBtn={mainBtn}
      onClick={onClick}
      smTitle={smTitle}
      title={title}
      routeSegments={routeSegments}
      rightRouteSegments={[{ name: 'Allocation', current: true }]}
      currency={currency}
      // sideBtn={sideBtn}
      // onClickAction={onClickAction}
    />
  )
}

const Subheader = () => {
  const { state }: locationState = useLocation()

  return (
    <DynamicSubHeader
      title={<text>{state?.docNo}</text>}
      rightText={<span className="c-orange">{formatDate(state?.docDate)}</span>}
      infoLine={
        state?.description
        // <div
        //   className="mdDesc"
        //   style={{ width: '50%', textOverflow: 'ellipsis' }}
        // >
        //   {state?.description}
        // </div>
      }
      rightInfoLine={
        <IconText
          icon={<img src={SubInfoDollarIcon} style={{ width: '12px' }} />}
          font="mdDesc"
          children={amtStr(state?.docAmt)}
        />
      }
    />
  )
}

interface allocationDetail {
  ID: string
  allocatedAmt: number
}
interface allocation {
  allocation: allocationDetail[]
}
interface errorProps {
  ID: string
  msg: string
}

const Listing = ({ item }) => {
  const { state }: locationState = useLocation()
  const [error, setError] = useState<errorProps[]>([])
  const { handleSubmit, errors, control, watch, register } = useForm<
    allocation
  >({
    mode: 'all',
    defaultValues: {
      // can only display properly when first time mount with value
      allocation: item?.list?.map(e => {
        return {
          ID: e?.ID,
          allocatedAmt: e?.allocatedAmt,
          disabled: e?.disabled,
        }
      }),
    },
  })

  const onSubmit = data => {
    // prepare data to submit
    const submittedData = item?.list?.map(e => {
      return {
        debitRefTable: e?.debitRefTable,
        debitID: e?.debitID,
        creditRefTable: e?.creditRefTable,
        creditID: e?.creditID,
        taxRate: e?.taxRate,
        disabled: e?.disabled,
        allocationAmt:
          data?.allocation?.find(x => x?.ID === e?.ID)?.allocatedAmt || 0,
      }
    })
    //send data to parent handlesubmit
    item?.handleOnSubmit(submittedData)
  }

  const calculateOSBalance = (osAmt, allocateAmt) => {
    // calculate os change
    return new BigNumber(osAmt)?.minus(watch(allocateAmt) || 0).toNumber()
  }
  const checkError = (value, osAmt, errorID) => {
    let temp = error
    // check if exceed amount
    if (value > osAmt && !!!temp?.find(e => e?.ID == errorID)) {
      temp.push({ ID: errorID, msg: 'Exceed OS amount' })
      setError(temp)
    }
    // remove error
    if (!(value > osAmt) && !!temp?.find(e => e?.ID == errorID)) {
      setError(temp?.filter(e => e?.ID != errorID))
    }
    // check if undefined
    if (value == undefined && !!!temp?.find(e => e?.ID == errorID)) {
      temp.push({ ID: errorID, msg: 'Insert value' })
      setError(temp)
    }
  }

  const getTotalAmt = () => {
    // calculate total allocation amt
    return watch('allocation')?.reduce((sum, amt) => sum + amt?.allocatedAmt, 0)
  }

  return (
    <>
      <ContentWrapper multiDynamicInfo footer float>
        <CardContents
          section={{
            header: {
              title: (
                <div style={{ display: 'flex' }}>
                  <span style={{ flex: '1 1' }}>Document</span>
                  <span>Allocate Amt</span>
                </div>
              ),
            },
          }}
        >
          <List className="core-list" disablePadding style={{ flex: '1' }}>
            {item?.list?.map((data, index) => {
              const controllerName = `allocation[${index}]`

              return (
                <ListItem
                  key={index}
                  style={{
                    boxShadow: 'none',
                    marginBottom: '0px',
                  }}
                >
                  <ListItemText
                    primary={
                      <>
                        <span className="desc date-width">
                          {formatDate(data?.docDate)}
                        </span>
                        <span
                          className={`mdLabel flex-space ${data?.onClick &&
                            'click-text'}`}
                        >
                          <span
                            onClick={() => item?.handleDownloadClick(data?.ID)}
                          >
                            {data?.claimDocNo || data?.docNo || data?.docRef}
                          </span>
                        </span>
                        <span className="xsTitle right-text">{`O/S: ${amtStr(
                          calculateOSBalance(
                            data?.outstandingAmt,
                            `${controllerName}.allocatedAmt`
                          )
                        )}`}</span>
                      </>
                    }
                    secondary={
                      <Grid container justify="flex-start">
                        <Grid item xs={8}>
                          <span className="desc flex-space text-noflow">
                            {data?.description || ''}
                          </span>
                        </Grid>
                        <Grid item xs={4}>
                          <Controller
                            render={({ onChange, value }) => {
                              return (
                                <NumberFormat
                                  customInput={TextField}
                                  className="price-input"
                                  style={{
                                    marginTop: '0px',
                                    marginBottom: '0px',
                                  }}
                                  variant="outlined"
                                  fullWidth
                                  margin="dense"
                                  allowNegative={false}
                                  thousandSeparator
                                  decimalScale={2}
                                  helperText={
                                    error?.find(e => e?.ID === data?.ID)?.msg
                                  }
                                  error={error?.find(e => e?.ID === data?.ID)}
                                  fixedDecimalScale
                                  onValueChange={({ floatValue }) => {
                                    checkError(
                                      floatValue,
                                      data?.outstandingAmt,
                                      data?.ID
                                    )
                                    onChange(floatValue)
                                  }}
                                  value={value}
                                  disabled={data?.disabled}
                                />
                              )
                            }}
                            name={`${controllerName}.allocatedAmt`}
                            ref={register}
                            control={control}
                          />
                          <Controller
                            as={TextField}
                            style={{ display: 'none' }}
                            name={`${controllerName}.ID`}
                            control={control}
                            ref={register}
                          />
                        </Grid>
                      </Grid>
                    }
                  />
                </ListItem>
              )
            })}
            {parseFloat(getTotalAmt().toFixed(2)) > state?.docAmt && (
              <ListItem
                style={{
                  boxShadow: 'none',
                  padding: '0px 10px',
                  color: 'red',
                }}
              >
                <ListItemText
                  primary={
                    <Grid container justify="flex-start" className="desc">
                      <Grid
                        item
                        xs={12}
                        className="color-red p-l-10 right-text"
                      >
                        {`Total allocation cannot exceeds document amount!`}
                      </Grid>
                    </Grid>
                  }
                />
              </ListItem>
            )}
          </List>
        </CardContents>
        <div className="footer" style={{ zIndex: 50 }}>
          <DynamicFooter
            title1="Balance"
            value1={state?.docAmt - getTotalAmt()}
            title2="Total"
            value2={getTotalAmt()}
            options={
              !item?.checkEnvoice
                ? [
                    {
                      name: 'Save',
                      onClick: () => {
                        handleSubmit(onSubmit)()
                      },
                      disabled:
                        parseFloat(getTotalAmt().toFixed(2)) > state?.docAmt ||
                        error?.length > 0,
                      color: 'primary',
                    },
                  ]
                : null
            }
          />
        </div>
      </ContentWrapper>
    </>
  )
}
